import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { ModalService } from 'pf-frontend-common/src/service/modal/service';

import { MyAccountConfirmationViewStore } from 'common/module/my-account/confirmation/view-store';
import { MyAccountStatechartService } from 'common/service/my-account-statechart/service';

export function MyAccountConfirmationViewStoreFactory(): MyAccountConfirmationViewStore {
  return new MyAccountConfirmationViewStore(EventEmitterFactory(), MyAccountStatechartService(), ModalService());
}
